module.exports = __webpack_public_path__ + "img/img1.d6056a76.d6056a76.jpg";